import { createSvgIcon } from '@mui/material';

const SIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="19.637" height="20.92" viewBox="0 0 19.637 20.92">
    <g id="Group_3003" data-name="Group 3003" transform="translate(-1014.588 -519.256)">
      <path
        id="Path_2815"
        data-name="Path 2815"
        d="M1024.422,535.1l8.8-4.216v10.6l-8.816,4.216V535.1l-8.816-4.344v10.6l8.8,4.344"
        transform="translate(0 -6.535)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        id="Path_2816"
        data-name="Path 2816"
        d="M1033.222,524.35l-8.944-4.344-8.688,4.216"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        id="Path_2817"
        data-name="Path 2817"
        d="M1024.658,524.676l8.731,4.429v3.833l2.257-1.193.023-3.8-8.69-4.36"
        transform="translate(-5.512 -2.178)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        id="Line_717"
        data-name="Line 717"
        x2="2.428"
        y2="1.235"
        transform="translate(1017.874 530.815)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        id="Line_718"
        data-name="Line 718"
        x2="1.548"
        y2="0.746"
        transform="translate(1017.874 533.038)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </g>
  </svg>,
  'SIcon',
);

export default SIcon;
